export default "__VITE_ASSET__Ull2XCCM__"